import React from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import './CookieConsentBanner.scss';

export function CookieConsentBanner() {
    const { consent, setConsent } = useCookieConsent();

    if (consent !== null) {
        return null;
    }

    return (
        <div className='cookie-consent' role='dialog' aria-label='Уведомление об использовании cookie'>
            <div className='cookie-consent__content'>
                <p className='cookie-consent__text'>
                    Для обеспечения удобства пользователей сайта используются cookies
                </p>
                <div className='cookie-consent__actions'>
                    <button
                        type='button'
                        className='cookie-consent__btn cookie-consent__btn--accept'
                        onClick={() => setConsent('accepted')}
                    >
                        Принять
                    </button>
                    <button
                        type='button'
                        className='cookie-consent__btn cookie-consent__btn--reject'
                        onClick={() => setConsent('rejected')}
                    >
                        Отклонить
                    </button>
                    <Link
                        to='/cookie-policy'
                        className='cookie-consent__link'
                    >
                        Подробнее
                    </Link>
                </div>
            </div>
        </div>
    );
}
